var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnBoardingGift = function SvgOnBoardingGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#onBoardingGift_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__b)",
    d: "M32.049 35.976h-28.1a1.333 1.333 0 0 1-1.332-1.333V13.156h30.765v21.487c0 .736-.597 1.333-1.333 1.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1CFFF",
    d: "M2.617 13.156h30.765v4.471H2.617z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__c)",
    d: "M36 8.495v5.539c0 .592-.48 1.07-1.072 1.07H1.071A1.07 1.07 0 0 1 0 14.035v-5.54c0-.59.48-1.07 1.07-1.07h33.858c.592 0 1.072.48 1.072 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCEAD1",
    d: "M16.776 9.971q-.351.409-.687.828a31 31 0 0 0-2.904 4.307H5.884a37.6 37.6 0 0 1 4.54-7.681 38 38 0 0 1 1.396-1.722l1.999 1.722.31.266 2.359 2.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__d)",
    d: "M18 9.972a31 31 0 0 0-2.976 4.081 31.2 31.2 0 0 0-4.26 11.771 31.4 31.4 0 0 1-2.54-3.963 33 33 0 0 0-3.933 3.015 37.8 37.8 0 0 1 8.752-19.173l2.309 1.988 2.36 2.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__e)",
    d: "M31.708 24.877a33 33 0 0 0-3.933-3.016 31.4 31.4 0 0 1-2.54 3.963A31.23 31.23 0 0 0 18 9.972l.288-.248 2.36-2.033 2.309-1.988q.272.316.536.637a37.792 37.792 0 0 1 8.216 18.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__f)",
    d: "M15.134 9.97h5.732v5.135h-5.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAAD74",
    d: "m27.492 12.259-6.517 1.794a31 31 0 0 0-2.288-3.255l-.4-1.074L18 8.949l2.649-1.258 2.844-1.351a37.7 37.7 0 0 1 4 5.919M18 8.948l-.288.775-.4 1.075a31 31 0 0 0-2.287 3.255l-6.516-1.795a37.7 37.7 0 0 1 3.999-5.918l2.844 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__g)",
    d: "M28.4.25 18 5.187l1.998 5.373 11.101-3.055a2.567 2.567 0 0 0 1.725-3.37l-.917-2.463A2.567 2.567 0 0 0 28.401.249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__h)",
    d: "M7.6.25 18 5.187l-1.998 5.373-11.1-3.055a2.567 2.567 0 0 1-1.725-3.37l.916-2.463A2.567 2.567 0 0 1 7.599.249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAAD74",
    d: "M20.483 7.348a.572.572 0 0 1-.31-1.056c.08-.05 1.953-1.242 4.103-2.112 3.1-1.254 5.17-1.187 6.153.2a.573.573 0 1 1-.935.663c-1.332-1.88-6.868 1.043-8.703 2.215a.57.57 0 0 1-.308.09M15.46 7.348a.57.57 0 0 1-.308-.09C13.317 6.086 7.78 3.163 6.449 5.043a.573.573 0 1 1-.935-.663c.982-1.387 3.052-1.454 6.153-.2 2.15.87 4.024 2.062 4.102 2.112a.573.573 0 0 1-.31 1.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAAD74",
    d: "M19.63 3.342h-3.262c-.892 0-1.616.724-1.616 1.616v4.74c0 .892.724 1.616 1.616 1.616h3.262c.893 0 1.617-.724 1.617-1.617V4.958c0-.892-.724-1.616-1.617-1.616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#onBoardingGift_svg__i)",
    d: "M15.134 15.106h5.732v20.87h-5.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAAD74",
    d: "M15.134 15.106h5.732v2.522h-5.732z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.513 3.57 7.888)scale(19.6102 17.2397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.44682 17.698 -15.55903 -7.42594 25.934 8.064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(128.033 6.65 9.783)scale(5.73294 6.29196)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(134.827 13.08 6.168)scale(13.0978 14.8106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.23347 9.2894 -10.5041 -10.44087 11.689 1.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "onBoardingGift_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.53201 18.357 -7.70298 -1.4821 18.452 17.555)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onBoardingGift_svg__b",
    x1: 28.904,
    x2: 19.087,
    y1: 11.346,
    y2: 36.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#378CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onBoardingGift_svg__c",
    x1: 30.76,
    x2: 29.675,
    y1: 6.815,
    y2: 16.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#378CF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "onBoardingGift_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgOnBoardingGift;